<div class="logo-wrapper">
  <div class="avatar-trigger" (click)="toggleMenu()" (keydown.enter)="toggleMenu()" tabindex="0">
    <img id="avatar-connected-user" [src]="userAvatar$ | async" alt="User Avatar" class="user-avatar" />
    @if (countGlobalNotifications$ | async; as countGlobalNotifications) {
      @if (countGlobalNotifications > 0) {
        <div class="global-badge-menu">
          <app-badge [badgeValue]="countGlobalNotifications"></app-badge>
        </div>
      }
    }
  </div>

  @if (isOpen) {
    <ul class="menu-list" @fadeMenu>
      <app-header-menu-messages [isOpenMenu]="isOpen"></app-header-menu-messages>
      <app-header-menu-reports [isOpenMenu]="isOpen"></app-header-menu-reports>

      <li class="menu-item" (click)="goToProfile()" (keydown.enter)="goToProfile()" tabindex="1">
        <i class="fa-solid fa-user"></i>
        Mon profil
      </li>
      <li id="logout" class="menu-item" (click)="logout()" (keydown.enter)="logout()" tabindex="1">
        <i class="fa-solid fa-arrow-right-from-bracket"></i>
        Se déconnecter
      </li>
    </ul>
  }
</div>
